<template>
  <section>
    
    <div class="box-content">
      
      <p>
        {{ $t('NEED_TO_REGISTER') }}  
      </p>

      <p>
        {{ $t('NEED_TO_REGISTER2') }}  
      </p>
      
      <a class="btn btn-primary btn-sm btn-fill text-white mt-2"  target="_blank" :href="register_url">{{ $t('CONTACT_US') }}</a>
    </div>

  </section>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  computed: {    
    register_url() {
      if(this.sefos_locale == "sv"){
        return  "https://sefos.se/kom-igang/";
      }else{
        return "https://sefos.se/en/kom-igang/";
      }
    }
  }
};
</script>
<style>
</style>
